<template>
  <div>
    <div class="mb-2">
      Відповідно до вимог Кредитного реєстру Національного банку України,
      кожному елементу набору даних (особа, актив, фінансове зобов’язання,
      забезпечення, транш тощо) має бути присвоєно унікальний ідентифікатор,
      який залишається незмінним упродовж усього періоду звітності.
    </div>

    <div class="mb-2">
      Ідентифікатори для Особи (розширені відомості, боржник) та Особи
      (скорочені відомості, пов’язана/інша особа) повинні збігатися у випадку,
      якщо йдеться про одну і ту саму особу.
    </div>

    <div>
      Ідентифікатор призначається один раз і використовується у звітності без
      змін до моменту закриття відповідного елементу даних.
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'CreatePackageAlert',
  setup() {
    const submit = () => {
      return Promise.resolve()
    }

    return { submit }
  },
}
</script>

<style scoped lang="scss"></style>
